import { useContext, useState } from 'react';
import Spinner from '../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../components/spinner/types/spinnerProps';
import Chip from '../../../components/shared/chip/chip';
import Characteristics from '../krFormView/components/characteristics';
import { ObjectType, PatternType } from '../../../contexts/types/card';
import Subsoil from '../krFormView/components/subsoil';
import ColluvialMaterial from '../krFormView/components/colluvialMaterial';
import WaterManifestation from '../krFormView/components/waterManifestation';
import GenesisAndAge from '../krFormView/components/genesisAndAge';
import ResearchState from '../krFormView/components/reasearchState';
import SecurityOptions from '../krFormView/components/securityOptions';
import ElaboratorsAndInstitutions from '../shared/ElaboratorsAndInstitutions/elaboratorsAndInstitutions';
import KrFormContext, { KrLandslideFormTypes, landSlideAttributes } from '../../../contexts/krFormContext';
import { CollectiveFormContextProps } from '../krFormView/components/shared/types/formContextProps';
import ThreatsAndDamage from '../krFormView/components/threatsAndDamage';
import LandUse from '../krFormView/components/landUse';
import Location from '../krFormView/components/location';
import './collectiveEditionView.scss';

const CollectiveLandslideForm = (props: CollectiveFormContextProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext);
    
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState<boolean>(false);

    const deleteKr = (attributes: landSlideAttributes) => {
        if (attributes?.numeR_IDENTYFIKACYJNY !== undefined) {
            props.onDelete([attributes?.numeR_IDENTYFIKACYJNY]);
        }
    }

    const elaboratorsSectionTitle = (
        <>
            <h2>18. Wypełniający kartę</h2>
            <h2>19. Kategoria i numer kwalifikacji geologicznych wypełniającego kartę</h2>
            <h2>20. Instytucja reprezentowana przez wypełniającego kartę</h2>
        </>
    );

    return (
        <div>
            {loading && <Spinner spinnerClass={ClassNameSpinner.Big} isMist={true} />}
            <div className='collectiveIds'>
                <h3>wybrane karty</h3>
                {props.forms.map((form: KrLandslideFormTypes) => {
                    return <Chip key={form.landslideAttributes?.id}
                        title={form.landslideAttributes?.numeR_IDENTYFIKACYJNY}
                        onlySingleTag={true}
                        mainClass={true}
                        onClose={deleteKr}
                        data={form.landslideAttributes} />
                })}
            </div>
            <div className='collective-fields'>
                <Location objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <Characteristics objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <Subsoil objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <ColluvialMaterial objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <WaterManifestation objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <GenesisAndAge objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <LandUse objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <ThreatsAndDamage objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <ResearchState objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <SecurityOptions objectType={ObjectType.KRO} version={PatternType.P2020} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
                <ElaboratorsAndInstitutions sectionTitle={elaboratorsSectionTitle} context={krForm} setContext={setkrForm} isKR={true} collectiveEdition={true} editMode={true}
                    forms={props.forms} actions={props.actions} setActions={props.setActions} onDelete={props.onDelete} />
            </div>
        </div>
    )
}

export default CollectiveLandslideForm;